module.exports = __webpack_public_path__ + "img/img15@2x.ab4912df.png";